import { DefaultLayout } from '@gsa/afp-component-library';
import { useCurrentUser } from '@gsa/afp-shared-ui-utils';
import React from 'react';
import useNavigationMenuStore from '../hooks/use-navigation-menu-store';
import { Outlet } from 'react-router-dom';
import ErrorContextProvider from '../Providers/ErrorContextProvider/ErrorContextProvider';

export default function Layout(){
  const { currentUser, isLoggedIn } = useCurrentUser();
  const menu = useNavigationMenuStore(false);
  return (
    <DefaultLayout currentUser={isLoggedIn && currentUser} menu={menu}>
      <ErrorContextProvider>
        <Outlet />
      </ErrorContextProvider>
    </DefaultLayout>
  );
};